<template>
  <h1>All Status</h1>
  <p v-if="error">{{ error }}</p>
  <p v-if="shouldLoadData">Loading data... {{ loadingPercent }}%</p>
  <p v-else>Results complete</p>
  <div v-for="statusItem in statusItems" :key="statusItem.initialLinks">
    <hr>
    <h2>Crawl {{ statusItem.crawlId }}</h2>
    <h3><span v-for="link in statusItem.initialLinks" :key="link">{{ link }}</span></h3>
    <p>Start time: {{ startDateString(statusItem) }} (duration (sec): {{ durationSeconds(statusItem) }}</p>
    <button :disabled="isCompleted(statusItem)" @click="shutdown(statusItem.crawlId)">Shutdown</button>
    <p>{{ loadingPercent(statusItem) }}%</p>
    <ul>
      <li v-for="(value, name) in statusItem" :key="name">
        {{ name }} = {{ statusItem[name] }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      error: null,
      statusItems: []
    };
  },
  methods: {
    async loadStatus() {
      const code = this.$route.query.code;
      if (! code) {
        return;
      }
      const statusResponse = await fetch(
        this.backendHost + "/allstatus?code=" + code
      );

      if (!statusResponse.ok) {
        this.error = "Oops... something went wrong with allstatus";
        return;
      }

      const statusJson = await statusResponse.json();

      const newStatusItems = [];
      for (const statusItem of statusJson) {
        newStatusItems.push({
          crawlState: statusItem.crawlState,
          initialLinks: statusItem.initialLinks,
          outstandingRequestCount: statusItem.outstandingRequestCount,
          completedRequestCount: statusItem.completedRequestCount,
          crawlId: statusItem.crawlIdentifier.stringValue,
          startTime: statusItem.startTime,
          lastStateTime: statusItem.lastStateTime,
          currentRequestRate: statusItem.currentRequestRate
        })
      }

      this.statusItems = newStatusItems;

      setTimeout(() => {
        this.loadStatus();
      }, 3000);
    },
    loadingPercent(statusItem) {
      return Math.floor(statusItem.completedRequestCount / (statusItem.outstandingRequestCount + statusItem.completedRequestCount) * 100);
    },
    async shutdown(crawlId) {
      const code = this.$route.query.code;
      if (! code) {
        return;
      }
      const statusResponse = await fetch(
        this.backendHost + "/shutdown/" + crawlId + "?code=" + code
      );

      if (!statusResponse.ok) {
        this.error = "Oops... something went wrong with shutdown";
        return;
      }
      //const statusJson = await statusResponse.json();
    },
    startDateString(statusItem) {
      return new Date(statusItem.startTime).toLocaleString();
    },
    durationSeconds(statusItem) {
      if (this.isCompleted(statusItem)) {
        return Math.floor((statusItem.lastStateTime - statusItem.startTime) / 1000);
      }
      return Math.floor((Date.now() - statusItem.startTime) / 1000);
    },
    isCompleted(statusItem) {
      return statusItem.crawlState.stateType !== 'RUNNING';
    }

  },
  mounted() {
    this.loadStatus();
  },
};
</script>

